import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "h-px" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "h-px" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["\n      inline-flex\n      items-center\n      font-display\n      text-xs\n      px-2\n      rounded-full\n      relative\n      box-border\n    ", {
      'text-amff-black': _ctx.color === 'amff-white',
      'text-amff-white':
        _ctx.color === 'amff-black' ||
        _ctx.color === 'amff-pink' ||
        _ctx.color === 'amff-light-pink',
      'text-amff-teal': _ctx.color === 'amff-pink-invert',
      'border-2': _ctx.outline,
      'border-white': _ctx.outline && _ctx.color !== 'amff-pink',
      'border-black': _ctx.outline && _ctx.color === 'amff-pink',
    }]
  }, [
    _createVNode("div", {
      class: ["absolute w-full h-full rounded-full left-0", {
        'bg-amff-white ': _ctx.color === 'amff-white',
        'bg-amff-black ':
          _ctx.color === 'amff-black' || _ctx.color === 'amff-pink-invert',
        'bg-amff-teal ': _ctx.color === 'amff-pink',
        'bg-amff-light-teal opacity-25': _ctx.color === 'amff-light-pink',
      }]
    }, null, 2),
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _renderSlot(_ctx.$slots, "default"),
      _hoisted_3
    ])
  ], 2))
}